import { formatarQuantidade } from '@/components/stock/stockFormat';

/**
 * O que a conclusão do recebimento reservou sozinha para os pedidos que esperavam a malha (§13.79) — o texto que o
 * estoquista lê ao terminar, para saber que o material que acabou de etiquetar JÁ tem dono.
 */
export interface ReservaDaChegada {
  order_id: string;
  numero_pedido: string | null;
  cliente: string | null;
  material: string;
  unidade: string;
  qty: number;
  /** PRAZO = o que o pedido pediu; SOBRA = o que passou do total, deixado no pedido de prazo menos urgente. */
  tipo: 'PRAZO' | 'SOBRA';
  prazo: string | null;
}

const MAX_PEDIDOS = 4;

export function resumoDasReservas(reservas: ReservaDaChegada[] | null | undefined): string | null {
  const lista = (reservas ?? []).filter((r) => r.qty > 0.0005);
  if (!lista.length) return null;
  const partes = lista.slice(0, MAX_PEDIDOS).map((r) =>
    `${r.numero_pedido ?? 'pedido'}: ${formatarQuantidade(r.qty, r.unidade)} de ${r.material}${r.tipo === 'SOBRA' ? ' (sobra)' : ''}`);
  const mais = lista.length > MAX_PEDIDOS ? ` e mais ${lista.length - MAX_PEDIDOS}` : '';
  const haSobra = lista.some((r) => r.tipo === 'SOBRA');
  return `Já separado para os pedidos — ${partes.join('; ')}${mais}.`
    + (haSobra ? ' A sobra fica no pedido de prazo menos urgente até o corte devolver.' : '');
}
